// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finance-event-cell[data-v-256cddcc] {\n  line-height: 13px;\n  font-size: 13px;\n  padding: 10px !important;\n  -webkit-transition: font 0.3s ease;\n  transition: font 0.3s ease;\n}\n.finance-event-cell-green[data-v-256cddcc] {\n    color: #12c971;\n}\n.finance-event-cell-red[data-v-256cddcc] {\n    color: #ff238d;\n}\n.finance-event-cell-black[data-v-256cddcc] {\n    color: #000000;\n}\n", ""]);
// Exports
module.exports = exports;
